export default __webpack_public_path__ + "static/media/GelBoxOpen.a7f86180.svg";